/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attr_Variety_TypeInputs */

const en_attr_variety_type = /** @type {(inputs: Attr_Variety_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const th_attr_variety_type = /** @type {(inputs: Attr_Variety_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชนิด`)
};

const ja_attr_variety_type = /** @type {(inputs: Attr_Variety_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイプ`)
};

const fr_attr_variety_type = /** @type {(inputs: Attr_Variety_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const es_attr_variety_type = /** @type {(inputs: Attr_Variety_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const ru_attr_variety_type = /** @type {(inputs: Attr_Variety_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип`)
};

const zh_attr_variety_type = /** @type {(inputs: Attr_Variety_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型`)
};

const vi_attr_variety_type = /** @type {(inputs: Attr_Variety_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Attr_Variety_TypeInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const attr_variety_type = /** @type {((inputs?: Attr_Variety_TypeInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attr_Variety_TypeInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_attr_variety_type(inputs)
	if (locale === "ja") return ja_attr_variety_type(inputs)
	if (locale === "fr") return fr_attr_variety_type(inputs)
	if (locale === "es") return es_attr_variety_type(inputs)
	if (locale === "ru") return ru_attr_variety_type(inputs)
	if (locale === "zh") return zh_attr_variety_type(inputs)
	if (locale === "vi") return vi_attr_variety_type(inputs)
	return en_attr_variety_type(inputs)
});